import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { cardClickOutput } from '../shared/components/card-item-list/card-item-list.component';
import { Bill_BillerService, Category, Provider, Service, eagerLoadedBillBillerService } from '../interfaces/biller-interfaces';
import { GetBillCategoryService } from 'src/app/dashboard/admin/action/components/bill-payments/bill-category/services/bill-category-get.service'
import { selectedServiceNotifierService } from './selectedServiceNotifer.service';
import { BillServiceListWithCategoryAndProviderService } from '../shared/services/billServiceListWithCategoryProvider.service'
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/shared/services/language.service';
@Component({
  selector: 'app-category-provider',
  templateUrl: './category-provider.component.html',
  styleUrls: ['./category-provider.component.scss']
})
export class CategoryProviderComponent implements OnInit {

  categoryId;
  billServiceList;
  providers: Provider[];
  providerServices: Service[];
  category: Category;
  selectedService: Service;
  BillbillerServices: eagerLoadedBillBillerService[] = [];
  public languages = ['ar', 'en'];
  public currentLanguages: string;

  constructor(
    private getCategory: GetBillCategoryService,
    private getBillServiceWithCategoryAndProv: BillServiceListWithCategoryAndProviderService,
    private activatedRoute: ActivatedRoute,
    private serviceNotifier: selectedServiceNotifierService,
    private location :Location,
    private router:Router,
    private translate: TranslateService,
    private languageService: LanguageService,


  ) { }

  async ngOnInit() {
    try {
    this.translate.use(localStorage.getItem("language"));
    this.languageService.languageUpdated.subscribe((lang: string) => {
      this.translate.use(lang);
    });
      this.categoryId = this.activatedRoute.snapshot.paramMap.get('categoryId');
      this.getCategory.setParams({ ID: this.categoryId });
      this.category = await this.getCategory.make();

      this.getBillServiceWithCategoryAndProv.setParams({CategoryID: this.categoryId});
      this.BillbillerServices = await this.getBillServiceWithCategoryAndProv.make();
      this.providers= this.BillbillerServices.map(res=>{
       return res.Provider
      }).filter((prov:Provider,index,arr)=>{
        return arr.findIndex(res=>res.ID==prov.ID)==index
      })
      this.serviceNotifier.pushbillProviderAndServices(this.BillbillerServices);

    } catch (err) {
      console.log(err);
    }
  }
  back(): void {
    this.router.navigate(['/seller/billPayments'])
}
  onClickProvider(event: cardClickOutput) {
    const providerId = event.id;
    this.providerServices = this.BillbillerServices.filter((res, index) => {
      return res.ProviderID == providerId
    }).map(res => res.Service);
    this.router.navigate([
      `/seller/billPayments/category/${this.categoryId}/provider/${providerId}`], { state: this.BillbillerServices });
    this.serviceNotifier.pushbillProviderAndServices(this.BillbillerServices);
  }

  changeLanguage(language: string): void {
    this.translate.use(language);
    localStorage.setItem('language', language);
    this.currentLanguages = language;
    document.body.setAttribute('lang' , language)
    if (language === 'ar') {
      document.body.classList.add('dir-rtl');
      return;
    }
    document.body.classList.remove('dir-rtl');
  }

}
